import React from 'react'

export default React.createContext({
  state: {},
  dispatch: () => {},
})
